<template>
  <div class="wrapper">
    <h1>设置项ui组件库文档</h1>
    <h4 style="margin-top: 16px">
      <strong>tips:</strong>该ui组件库仅适用于以.sync的方式双向绑定props，且对数据的处理均由父组件完成
    </h4>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="大屏" name="first"><example type="bigScreen" v-if="activeName === 'first'" /></el-tab-pane>
      <el-tab-pane label="portal2.0" name="second">
        <example type="portal" v-if="activeName === 'second'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import "assets/css/common.css"
import "assets/css/big_screen_common.css"
import "assets/css/options.css"
import "assets/icomoon/style.css"
import example from "./example.vue"
export default {
  components: {
    example
  },
  data() {
    return {
      activeName: "first"
    }
  },
  methods: {
    handleClick(tab, event) {}
  }
}
</script>
<style scoped>
.wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 100%;
}
</style>
<style>
.el-color-picker__panel {
  background: #1f2124;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.6), 0 9px 28px rgba(0, 0, 0, 0.3), 0 12px 48px 16px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.el-color-picker__panel .el-input .el-input__inner {
  background: #35383f;
  border-radius: 4px;
  /*color: #c0c4cc;*/
  border-color: transparent;
}
.el-color-picker__panel .el-button--default {
  background: var(--themeColor);
  color: #fff;
  border: none;
}
.el-color-picker__panel .el-button--mini,
.el-button--mini.is-round {
  padding: 8px 14px;
}
</style>
